<template>
    <v-container>
      <v-row>
          <v-col cols="12">
            <div class="text-left" style="margin-bottom:20px;">
                <router-link to="/">
                    <v-btn
                        color="secondary"
                        class="text-right"
                        style="width:250px"
                    >
                        Back
                    </v-btn>
                </router-link>
              </div>                  
          </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h1>Super Bowl LX View Party</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:-100px;">
            February 5, 2026, Sydney to Las Vegas
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:0px;">
            Super Bowl LX View Party - Caesars Palace February 8, 2026
          </div>
        </v-col>
      </v-row>                    
      <v-row>
        <v-col cols="12">
          <div class="text-left" style="margin-bottom:20px;">
            <a href="https://www.caesars.com/caesars-palace" target="_blank">
              <v-btn
                color="primary"
                class="text-right"
                style="width:500px; margin-top:15px;"
              >
                Caesars Palace
              </v-btn>
            </a>
          </div>
        </v-col>
      </v-row>      
      <div class="text-left">Las Vegas to Sydney February 11, 2026</div>
      <div class="text-left">Arrive Sydney February 13, 2026</div>

    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>

